import { render, staticRenderFns } from "./Store.vue?vue&type=template&id=1315c7fb&scoped=true"
import script from "./Store.vue?vue&type=script&lang=js"
export * from "./Store.vue?vue&type=script&lang=js"
import style0 from "./Store.vue?vue&type=style&index=0&id=1315c7fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1315c7fb",
  null
  
)

export default component.exports